import React from 'react';
import PropTypes from 'prop-types';

export default function CoverMessage({
  buyerApplicationData,
  breederName,
  programName
}) {
  const {
    value: {
      buyer_application: {
        buyer_profile_attributes: {
          id: buyerId,
          user_attributes: { first_name: firstName }
        }
      }
    }
  } = buyerApplicationData;

  if (!buyerId) {
    return (
      <p className="mb8" data-test-id="cover-message">
        Before you start chatting with {breederName} at {programName}, share a
        little bit about yourself so they can learn more about what you&apos;re
        looking for.
      </p>
    );
  }

  return (
    <div data-test-id="buyer-cover-message">
      <p className="mb8">
        Welcome back, {firstName}! Before you start chatting with {breederName}{' '}
        at {programName}, share a little bit about yourself so they can learn
        more about what you&apos;re looking for.
      </p>
      <p className="mb8">
        We&apos;ll pre-fill your new application with your saved info.
        You&apos;ll still be able to edit your answers.
      </p>
    </div>
  );
}

CoverMessage.propTypes = {
  breederName: PropTypes.string.isRequired,
  programName: PropTypes.string.isRequired,
  buyerApplicationData: PropTypes.shape({
    value: PropTypes.shape({
      buyer_application: PropTypes.shape({
        buyer_profile_attributes: PropTypes.shape({
          id: PropTypes.number,
          user_attributes: PropTypes.shape({
            first_name: PropTypes.string
          }).isRequired
        }).isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
